import { fetchUsers } from "../../api";

const USERS_PAGE_SIZE = 1000;
const MAX_USER_PAGES = 10;

// Every user (the API pages at most 1000 at a time), for the admin schedule
// pages' coach lists and children counts.
export default async function loadAllUsers() {
  const users = [];
  for (let page = 1; page <= MAX_USER_PAGES; page += 1) {
    const response = await fetchUsers({ limit: USERS_PAGE_SIZE, page });
    const pageUsers = Array.isArray(response?.data) ? response.data : [];
    users.push(...pageUsers);
    if (pageUsers.length === 0 || page >= (response?.pagination?.pages || 1)) break;
  }
  return users;
}
